import { lazy } from "react";

const CreateEdit = lazy(() =>
  import("../../pages/UserAccess/PageAccessProfileMapping/create-edit"),
);

const routes = [
  {
    path: "/page_access_profile_mapping",
    element: lazy(() =>
      import("../../pages/UserAccess/PageAccessProfileMapping/index"),
    ),
  },
  {
    path: "/page_access_profile_mapping/add",
    element: CreateEdit,
  },
  {
    path: "/page_access_profile_mapping/edit/:id",
    element: CreateEdit,
  },
];

export default routes;
